'use client'
import { getProfileDetail } from "@/apis/profile"
import { AuthorizationError } from "@/errors/AuthorizationError"
import { useUserDetailStore } from "@/store/useUserDetailStore"
import { useUserStore } from "@/store/useUserStore"
import { useQuery } from "@tanstack/react-query"
import { useEffect, useState } from "react"

export const useUserUpdateDetail = () => {
  const [update, clear] = useUserDetailStore(state => [state.setDetail, state.clearDetail])
  const [isLogined, isPending, unLogin] = useUserStore(state => [state.isLogined, state.isPending, state.unLogin])

  const detail = useQuery({
    queryKey: ['user', 'detail'],
    queryFn: () => getProfileDetail(),
    enabled: isLogined && !isPending,
    retry: false,
  })

  useEffect(() => {
    if (!detail.isPending) {
      if (detail.isError) {
        if (isLogined) {
          clear()
          unLogin()
          throw new AuthorizationError()
        }
      }
      update(detail.data?.data)
    }
  }, [detail.data, detail.isPending, isLogined])
}